/* eslint-disable react/no-danger */
import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import PropTypes from 'prop-types';
import {clearAllBodyScrollLocks} from "body-scroll-lock";
import {trackEvent} from '../../helpers/listeners/analytics';
import {stripTags, stripTagsModified, filterHeadline, filterHTML} from "../../helpers/filters";
import {trackEventByUrl} from "../../helpers/events";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";

class CareersArticle extends Component {
    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        post: PropTypes.object.isRequired,
        toggleKeyword: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        location: PropTypes.object.isRequired,
        imageLoaded: PropTypes.func.isRequired,
        imagesHaveAllRendered: PropTypes.bool
    };

    static defaultProps = {
        imagesHaveAllRendered: false
    };

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    state = {
        modalIsOpen: false,
        imageLoaded: false
    };

    getExcerpt = (post) => {
        if (!post) return null;

        if (post.excerpt && post.excerpt.length > 0) {
            return (<div className="articleExcerpt" dangerouslySetInnerHTML={{__html: post.excerpt}}/>);
        }

        const content = post.body;

        if (!content) return null;

        let filtered = filterHTML(stripTagsModified(content, []));

        if (filtered.length >= 300) {
            filtered = `<p>${filtered.substring(0, 297)}...</p>`;
        }

        return (<div className="articleExcerpt" dangerouslySetInnerHTML={{__html: filtered}}/>);
    };

    openModal = videoId => {
        const {post} = this.props;
        if (videoId && videoId.id) {
            trackEvent('Video', 'Play', `${stripTags(post.title)} - ${videoId.type}:${videoId.id}`);
            this.setState({modalIsOpen: true});
        }
    };

    scrollToAnchor = () => {
        clearAllBodyScrollLocks();

        // Don't scroll if CSS ID is missing or URL hash is missing
        if (!this.myRef || !this.props.post.cssId || !this.props.location.hash) return;

        // Don't scroll if Hash doesn't match
        if (this.props.location.hash !== `#${this.props.post.cssId}`) return;

        this.myRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        })
    };

    render() {
        const {post, toggleKeyword, imageLoaded, imagesHaveAllRendered} = this.props;

        const isArticleLink = post.entityBundle === 'article' && post.entityUrl && post.entityUrl.path;

        const videoId = post.isVideoLink && post.link && post.link.uri && post.link.uri !== 'internal:/' ? ReactVideoModal.getVideoId(post.link.uri) : null;
        const downloadableFile = post.downloadableFile && post.downloadableFile.entity && post.downloadableFile.entity.fieldFile && post.downloadableFile.entity.fieldFile.entity && post.downloadableFile.entity.fieldFile.entity.url ? post.downloadableFile.entity.fieldFile.entity.url : '';

        if (imagesHaveAllRendered) {
            this.scrollToAnchor();
        }

        const permalink = (post.permalink) ? post.permalink.replace(/^\/story\//, "/careers/stories/") : null;

        return (
            <article key={`kcpost_${post.id}`} id={post.cssId} ref={this.myRef}>
                {videoId && (
                    <ReactVideoModal inline={false} eventButtonTitle={post.link.title || 'Watch Video'} uri={post.link.uri} onClose={() => this.setState({modalIsOpen: false})} isOpen={this.state.modalIsOpen}/>
                )}
                {post.featured_image && post.featured_image.url ? (
                    <img onLoad={imageLoaded} src={post.featured_image.url} alt={post.featured_image.alt}/>
                ) : null}

                <div className="careers__articleText">
                    {post.fieldSubtitle ? (
                        <p className="articleSubtitle">{post.fieldSubtitle}</p>
                    ) : null}

                    {post.title && (
                        <h3 dangerouslySetInnerHTML={{__html: filterHeadline(post.title)}}/>
                    )}

                    {this.getExcerpt(post)}

                    {isArticleLink && (
                        <a className="button button--ghost" href={permalink}>Read More</a>
                    )}
                    {!isArticleLink && !post.isVideoLink && permalink && (
                        <a target={permalink !== 'internal:/' ? '_blank' : '_self'}  className="button button--ghost"
                           rel="noreferrer noopener"
                           onClick={() => trackEventByUrl(permalink !== 'internal:/' ? permalink : downloadableFile, post.list_link_title || 'Read More')}
                           href={permalink !== 'internal:/' ? permalink : downloadableFile}>
                            {post.list_link_title || 'Read More'}
                        </a>
                    )}
                    {!isArticleLink && videoId && (
                        <button className="button button--ghost" onClick={() => this.openModal(videoId)}>
                            {post.link.title || 'Watch Video'}
                        </button>
                    )}

                    {post.tags && post.tags.length ? (
                        <div className="kcpost__keywords kcpost__keywords--no-top-border">
                            {post.tags.map(tag => (
                                <button key={`kcpost_${post.id}_keyword_${tag.slug.trim()}`} className="kcpost__keyword" onClick={e => toggleKeyword(e, tag.name.trim(), true)}>
                                    {tag.name.trim()}
                                </button>
                            ))}
                        </div>
                    ) : null}

                </div>

            </article>
        )
    }
}

export default withRouter(CareersArticle);



// WEBPACK FOOTER //
// ./frontend/components/Careers/CareersArticle.jsx